{
  "familyId": "SWW-TT-INV-JIJ",
  "questions": [
    {
      "id": "SWW-TT-INV-JIJ-001",
      "familyId": "SWW-TT-INV-JIJ",
      "module": "SpellingWW",
      "tier": 3,
      "levelCode": "M6",
      "group": 6,
      "skill": "tegenwoordige_tijd",
      "subSkill": "tt_inversie_basis",
      "questionType": "multiple_choice",
      "question": "Morgen ... jij naar de tandarts. (gaan)",
      "context": null,
      "options": ["ga", "gaat", "ging", "gegaan"],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": { "title": "Inversie Regel", "content": "Bij inversie staat 'jij' ACHTER het werkwoord. Dan gebruik je alleen de stam (geen -t): ga jij, loop jij, werk je.", "icon": "lightbulb" }
        }
      ],
      "conceptId": "present_tense_inversion_jij",
      "variantIndex": 1,
      "citoDifficulty": 0.28,
      "citoDiscrimination": 0.74,
      "feedback": {
        "explanationText": "Regel: inversieregel. Stap 1: Bij inversie (omkering) staat 'jij' ACHTER het werkwoord. Stap 2: Dan valt de -t weg en gebruik je alleen de stam. Stap 3: De stam van 'gaan' is 'ga'. Dus: '... ga jij ...' (niet 'gaat jij'). Vergelijk: 'Jij gaat' → 'Ga jij?'",
        "solutionSteps": [
          "Herken inversie: 'jij' staat ACHTER het werkwoord",
          "Bij inversie met jij: gebruik alleen de stam (geen -t)",
          "De stam van 'gaan' is 'ga'",
          "Antwoord: 'Morgen ga jij naar de tandarts.'"
        ],
        "distractorExplanations": {
          "0": "Correct! Inversieregel: bij inversie met 'jij' gebruik je alleen de stam: ga (zonder -t).",
          "1": "Bij inversie valt de -t weg. 'Gaat' is de gewone jij-vorm ('Jij gaat'), maar als jij achter het werkwoord staat, wordt het 'Ga jij?' Onthoud: inversie = geen -t.",
          "2": "'Ging' is de verleden tijd van 'gaan'. Het signaalwoord 'morgen' wijst op de toekomst, dus gebruik je de tegenwoordige tijd: ga.",
          "3": "'Gegaan' is het voltooid deelwoord en hoort bij 'ben gegaan'. Hier is geen hulpwerkwoord, dus gebruik je gewoon de tegenwoordige tijd: ga."
        }
      }
    },
    {
      "id": "SWW-TT-INV-JIJ-002",
      "familyId": "SWW-TT-INV-JIJ",
      "module": "SpellingWW",
      "tier": 3,
      "levelCode": "M6",
      "group": 6,
      "skill": "tegenwoordige_tijd",
      "subSkill": "tt_inversie_basis",
      "questionType": "text_highlight",
      "question": "Klik op het woord met een inversie-fout:",
      "context": "Loopt jij ook mee naar de winkel?",
      "options": [],
      "correctAnswer": 0,
      "data": {
        "segments": [
          {"id": "seg-0", "text": "Loopt", "isCorrect": true, "isTappable": true},
          {"id": "sep-0", "text": " ", "isTappable": false},
          {"id": "seg-1", "text": "jij", "isCorrect": false, "isTappable": true},
          {"id": "sep-1", "text": " ", "isTappable": false},
          {"id": "seg-2", "text": "ook", "isCorrect": false, "isTappable": true},
          {"id": "sep-2", "text": " ", "isTappable": false},
          {"id": "seg-3", "text": "mee", "isCorrect": false, "isTappable": true},
          {"id": "sep-3", "text": " ", "isTappable": false},
          {"id": "seg-4", "text": "naar", "isCorrect": false, "isTappable": true},
          {"id": "sep-4", "text": " ", "isTappable": false},
          {"id": "seg-5", "text": "de", "isCorrect": false, "isTappable": true},
          {"id": "sep-5", "text": " ", "isTappable": false},
          {"id": "seg-6", "text": "winkel?", "isCorrect": false, "isTappable": true}
        ]
      },
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": { "title": "Inversie Regel", "content": "Bij inversie staat 'jij' ACHTER het werkwoord. Dan valt de -t weg: Loop jij? (niet Loopt jij).", "icon": "lightbulb" }
        }
      ],
      "conceptId": "inversion_error_text_highlight",
      "variantIndex": 2,
      "citoDifficulty": 0.35,
      "citoDiscrimination": 0.70,
      "feedback": {
        "explanationText": "'Loopt' is fout bij inversie met 'jij'. De inversieregel zegt: jij achter werkwoord = geen -t. Dus: Loop jij (niet Loopt jij). Vergelijk: 'Jij loopt' → 'Loop jij?'",
        "solutionSteps": [
          "Lees de zin: 'Loopt jij ook mee naar de winkel?'",
          "Herken inversie: 'jij' staat achter het werkwoord 'Loopt'",
          "Bij inversie met jij valt de -t weg: Loopt → Loop",
          "De fout zit in 'Loopt' — moet 'Loop' zijn"
        ],
        "distractorExplanations": {
          "0": "Correct! 'Loopt' moet 'Loop' zijn. Bij inversie met jij valt de -t weg: Loop jij?"
        }
      }
    },
    {
      "id": "SWW-TT-INV-JIJ-003",
      "familyId": "SWW-TT-INV-JIJ",
      "module": "SpellingWW",
      "tier": 3,
      "levelCode": "M6",
      "group": 6,
      "skill": "tegenwoordige_tijd",
      "subSkill": "tt_inversie_basis",
      "questionType": "multiple_choice",
      "question": "Welke zin is correct geschreven?",
      "options": [
        "Werk jij vandaag op kantoor?",
        "Werkt jij vandaag op kantoor?",
        "Werken jij vandaag op kantoor?",
        "Gewerkt jij vandaag op kantoor?"
      ],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": { "title": "Inversie Regel", "content": "Bij inversie staat 'jij' ACHTER het werkwoord. Dan valt de -t weg en gebruik je alleen de stam: werk jij (niet werkt jij). Vergelijk: 'Jij werkt' → 'Werk jij?'", "icon": "lightbulb" }
        }
      ],
      "conceptId": "inversion_correct_sentence",
      "variantIndex": 3,
      "citoDifficulty": 0.30,
      "citoDiscrimination": 0.73,
      "feedback": {
        "explanationText": "'Werk jij' is correct. Bij inversie staat 'jij' achter het werkwoord, en dan valt de -t weg. De stam van 'werken' is 'werk'. Vergelijk: 'Jij werkt' (gewone volgorde) → 'Werk jij?' (inversie, geen -t).",
        "solutionSteps": [
          "Herken inversie: 'jij' staat achter het werkwoord",
          "Stam van 'werken' = werk",
          "Bij inversie: stam zonder -t → werk jij",
          "'Werk jij vandaag op kantoor?' is correct ✓"
        ],
        "distractorExplanations": {
          "0": "Goed! 'Werk jij' is correct — bij inversie valt de -t weg.",
          "1": "Je dacht waarschijnlijk dat jij altijd -t krijgt. Maar bij inversie (jij achter het werkwoord) valt de -t weg: werk jij, niet werkt jij. Onthoud: inversie = geen -t.",
          "2": "'Werken' is de infinitief of meervoudsvorm (wij werken). Bij jij gebruik je de stam: werk. Onthoud: jij-vorm = stam (+ t bij gewone volgorde, zonder t bij inversie).",
          "3": "'Gewerkt' is het voltooid deelwoord. Dat hoort bij 'heb gewerkt'. Hier heb je de tegenwoordige tijd nodig: werk jij."
        }
      }
    },
    {
      "id": "SWW-TT-INV-JIJ-004",
      "familyId": "SWW-TT-INV-JIJ",
      "module": "SpellingWW",
      "tier": 3,
      "levelCode": "M6",
      "group": 6,
      "skill": "tegenwoordige_tijd",
      "subSkill": "tt_inversie_basis",
      "questionType": "fill_in",
      "question": "Vul de juiste vorm in: '... jij altijd zo vroeg op?' (staan)",
      "options": [],
      "correctAnswer": 0,
      "data": {
        "acceptedAnswers": ["Sta", "sta"],
        "caseSensitive": false,
        "placeholder": "..."
      },
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": { "title": "Inversie Regel", "content": "Bij inversie staat 'jij' ACHTER het werkwoord. Dan gebruik je alleen de stam (geen -t). De stam van 'staan' is 'sta'. Dus: Sta jij? (niet Staat jij).", "icon": "lightbulb" }
        }
      ],
      "conceptId": "inversion_fill_in",
      "variantIndex": 4,
      "citoDifficulty": 0.35,
      "citoDiscrimination": 0.71,
      "feedback": {
        "explanationText": "De stam van 'staan' is 'sta'. Bij inversie (jij achter het werkwoord) gebruik je alleen de stam, zonder -t. Dus: 'Sta jij altijd zo vroeg op?' Vergelijk: 'Jij staat vroeg op' → 'Sta jij vroeg op?'",
        "solutionSteps": [
          "Herken inversie: 'jij' staat achter het werkwoord",
          "Stam van 'staan' = sta",
          "Bij inversie: geen -t → sta jij",
          "Antwoord: 'Sta jij altijd zo vroeg op?'"
        ]
      }
    },
    {
      "id": "SWW-TT-INV-JIJ-005",
      "familyId": "SWW-TT-INV-JIJ",
      "module": "SpellingWW",
      "tier": 3,
      "levelCode": "M6",
      "group": 6,
      "skill": "tegenwoordige_tijd",
      "subSkill": "tt_inversie_basis",
      "questionType": "multiple_choice",
      "question": "In welke zin is de inversieregel GOED toegepast?",
      "options": [
        "Fiets jij elke dag naar school?",
        "Fietst jij elke dag naar school?",
        "Jij fiets elke dag naar school.",
        "Fietsen jij elke dag naar school?"
      ],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": { "title": "Inversie Regel", "content": "Bij inversie staat 'jij' ACHTER het werkwoord → geen -t. Bij gewone volgorde staat 'jij' VOOR het werkwoord → wél -t. Vergelijk: 'Jij fietst' → 'Fiets jij?'", "icon": "lightbulb" }
        }
      ],
      "conceptId": "inversion_recognition",
      "variantIndex": 5,
      "citoDifficulty": 0.32,
      "citoDiscrimination": 0.72,
      "feedback": {
        "explanationText": "'Fiets jij' is correct. Bij inversie staat 'jij' achter het werkwoord, dus valt de -t weg. De stam van 'fietsen' is 'fiets'. Vergelijk: 'Jij fietst' (gewone volgorde, met -t) → 'Fiets jij?' (inversie, zonder -t).",
        "solutionSteps": [
          "Check elke zin op inversie (jij achter werkwoord)",
          "'Fiets jij' → inversie, stam zonder -t → correct ✓",
          "'Fietst jij' → inversie maar met -t → fout",
          "'Jij fiets' → gewone volgorde maar zonder -t → fout",
          "'Fietsen jij' → infinitief, niet de stam → fout"
        ],
        "distractorExplanations": {
          "0": "Goed! 'Fiets jij' is correct — inversie met stam zonder -t.",
          "1": "Bij inversie valt de -t weg! 'Fietst jij' is fout — het moet 'Fiets jij' zijn. Onthoud: jij achter werkwoord = geen -t.",
          "2": "'Jij fiets' is fout. Bij gewone volgorde (jij VOOR het werkwoord) krijg je wél -t: 'Jij fietst'. Onthoud: gewone volgorde = stam + t.",
          "3": "'Fietsen' is de infinitief (hele werkwoord). Bij jij gebruik je de stam: fiets. Onthoud: jij-vorm = stam (+ t bij gewone volgorde, zonder t bij inversie)."
        }
      }
    },
    {
      "id": "SWW-TT-INV-JIJ-006",
      "familyId": "SWW-TT-INV-JIJ",
      "module": "SpellingWW",
      "tier": 5,
      "levelCode": "E6",
      "group": 6,
      "skill": "werkwoorden",
      "subSkill": "ww_tt_inversie",
      "questionType": "error_spotting",
      "question": "Zoek de fouten in deze tekst. Tik op een fout woord en typ de verbetering.",
      "options": [],
      "correctAnswer": 0,
      "data": {
        "text": "Jij loopt snel naar school. Loopt jij altijd zo hard? Waarom wacht jij niet even? Wacht jij op mij?",
        "errors": [
          { "word": "Loopt", "position": 5, "correction": "Loop", "rule": "Inversie bij jij: stam zonder -t (Loop jij)" }
        ]
      },
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Inversie: jij achter het werkwoord",
            "content": "Als 'jij' of 'je' ACHTER het werkwoord staat, valt de -t weg. Je gebruikt dan alleen de stam. Dus: Jij loopt, maar: Loop jij? Jij wacht, maar: Wacht jij?",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "inversie_error_spotting",
      "variantIndex": 6,
      "citoDifficulty": 0.35,
      "citoDiscrimination": 0.75,
      "feedback": {
        "explanationText": "In de zin 'Loopt jij altijd zo hard?' staat 'jij' achter het werkwoord. Dit heet inversie. Bij inversie met jij/je valt de -t weg. Het moet dus zijn: 'Loop jij'. Bij 'Jij loopt' staat jij ervóór, dus wel een -t. Bij 'Wacht jij' eindigt de stam al op een -t, dus dat blijft gewoon 'wacht'.",
        "solutionSteps": [
          "Check 'Jij loopt': gewone volgorde → stam + t (loopt) = goed",
          "Check 'Loopt jij': inversie → stam zonder t (loop) = fout",
          "Check 'wacht jij': inversie → stam zonder t (wacht) = goed"
        ]
      }
    },
    {
      "id": "SWW-TT-INV-JIJ-011",
      "familyId": "SWW-TT-INV-JIJ",
      "module": "SpellingWW",
      "tier": 3,
      "levelCode": "M6",
      "group": 6,
      "skill": "tegenwoordige_tijd",
      "subSkill": "tt_inversie_basis",
      "questionType": "fill_in",
      "question": "Vul in: Wanneer ... (komen) jij naar het feest?",
      "correctAnswer": "kom",
      "data": {
        "acceptedAnswers": ["kom"],
        "placeholder": "werkwoord invullen...",
        "inputType": "text"
      },
      "stimulusAids": [],
      "supportAids": [
        { "type": "rule", "showWhen": "wrong", "data": { "title": "Inversie met jij", "content": "Bij inversie (jij achter het werkwoord) valt de -t weg. Komen → stam = kom. Inversie: kom jij (niet komt jij).", "icon": "lightbulb" } }
      ],
      "conceptId": "inversie_fill_in_kom",
      "variantIndex": 11,
      "citoDifficulty": 0.25,
      "citoDiscrimination": 0.76,
      "feedback": {
        "explanationText": "'Jij' staat achter het werkwoord (inversie). Bij inversie met jij valt de -t weg. Stam van 'komen' = kom. Dus: 'Wanneer kom jij naar het feest?'",
        "solutionSteps": [
          "Stam van 'komen' = kom",
          "'Jij' staat achter het werkwoord → inversie",
          "Inversie met jij → geen -t: kom jij"
        ]
      }
    },
    {
      "id": "SWW-TT-INV-JIJ-012",
      "familyId": "SWW-TT-INV-JIJ",
      "module": "SpellingWW",
      "tier": 3,
      "levelCode": "M6",
      "group": 6,
      "skill": "tegenwoordige_tijd",
      "subSkill": "tt_inversie_basis",
      "questionType": "error_spotting",
      "question": "Vind de inversiefouten in deze zinnen.",
      "correctAnswer": null,
      "data": {
        "text": "Gaat jij mee naar het zwembad? Jij loopt altijd zo snel. Fietst jij elke dag naar school?",
        "errors": [
          { "word": "Gaat", "correction": "Ga", "startIndex": 0, "endIndex": 4, "explanation": "Bij inversie (jij achter het werkwoord) valt de -t weg. Gaan → stam = ga. Inversie: ga jij (niet gaat jij)." },
          { "word": "Fietst", "correction": "Fiets", "startIndex": 56, "endIndex": 62, "explanation": "Bij inversie valt de -t weg. Fietsen → stam = fiets. Inversie: fiets jij (niet fietst jij)." }
        ]
      },
      "stimulusAids": [],
      "supportAids": [
        { "type": "rule", "showWhen": "wrong", "data": { "title": "Inversie met jij", "content": "Bij inversie (jij achter het werkwoord) valt de -t weg. Ga jij, loop jij, fiets jij. Maar: jij gaat, jij loopt, jij fietst (geen inversie = wel -t).", "icon": "lightbulb" } }
      ],
      "conceptId": "inversie_error_spotting",
      "variantIndex": 12,
      "citoDifficulty": 0.30,
      "citoDiscrimination": 0.74,
      "feedback": {
        "explanationText": "Twee fouten: 1) 'Gaat jij' → 'Ga jij' (inversie: -t valt weg). 2) 'Fietst jij' → 'Fiets jij' (inversie: -t valt weg). 'Jij loopt' is correct: geen inversie, dus wel -t.",
        "solutionSteps": [
          "Check: staat 'jij' achter het werkwoord? Dan inversie → geen -t",
          "'Gaat jij' → inversie → ga jij",
          "'Fietst jij' → inversie → fiets jij",
          "'Jij loopt' → geen inversie → wel -t ✓"
        ]
      }
    }
  ]
}